export enum DefaultDisplayValue {
  DASH = '—',
  NA = 'N/A',
  HyphenMinus = '-',
  NotAuthorized = 'Not Authorized',
}
